import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { ERROR_MESSAGES } from '~/constants/messages'

import Button from '../common/Button'
import Modal from '../common/Modal'
import Textarea from '../common/Textarea'

interface ModalCancelQueueProps {
  isOpen: boolean
  isLoading: boolean
  queueNo?: string
  closeModal: () => void
  confirmCancel: (reason: string) => void
}

interface CancelForm {
  cancel_reason: string
}

const ModalCancelQueue = ({ isOpen, isLoading, queueNo, closeModal, confirmCancel }: ModalCancelQueueProps) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<CancelForm>({ defaultValues: { cancel_reason: '' } })

  useEffect(() => {
    if (isOpen) {
      reset({ cancel_reason: '' })
    }
  }, [isOpen, reset])

  const onSubmit = (data: CancelForm) => confirmCancel(data.cancel_reason.trim())

  return (
    <Modal isOpen={isOpen} closeModal={() => closeModal()} showCloseButton={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-2 text-sm font-bold text-jba-blue">Batalkan antrean {queueNo}?</div>
        <div className="mb-4 text-xs text-gray-500">
          Antrean akan ditutup dan kode unik tidak dapat dipakai lagi. User harus mengajukan ulang pengambilan
          (memperbaiki surat) untuk mendapatkan kode unik baru.
        </div>
        <label htmlFor="cancel_reason" className="mb-1 block text-xs text-jba-blue">
          Alasan pembatalan
        </label>
        <div className="mb-4">
          <Controller
            name="cancel_reason"
            control={control}
            rules={{
              validate: (value) => value.trim() !== '' || ERROR_MESSAGES.REQUIRED_CANCEL_REASON,
              maxLength: { value: 500, message: ERROR_MESSAGES.MAXIMUM_500 },
            }}
            render={({ field }) => (
              <Textarea
                value={field.value}
                placeholder="Contoh: nama penerima kuasa di surat tidak sesuai KTP"
                onChange={(e) => field.onChange(e.target.value)}
                errorMessage={errors.cancel_reason?.message}
              />
            )}
          />
        </div>
        <div className="grid grid-cols-2 gap-x-4">
          <Button type="submit" variant="secondary" block rounded="xl" isLoading={isLoading}>
            Ya, Batalkan
          </Button>
          <Button onClick={() => closeModal()} type="button" variant="primary" plain block rounded="xl">
            Tidak
          </Button>
        </div>
      </form>
    </Modal>
  )
}

export default ModalCancelQueue
